import { Button } from '@repo/ui/button'
import { CommandShortcut } from '@repo/ui/command'
import { useT } from '@repo/ui/hooks'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { RotateCcwIcon } from 'lucide-react'
import { useEffect } from 'react'

import { usePreventLeave } from '@/hooks'

export function ResetAndUpdate({
  disabled,
  onReset,
  onUpdate,
}: {
  disabled: boolean
  onReset: () => void
  onUpdate: () => void
}) {
  const { tc } = useT()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.metaKey && e.key === 's') {
        e.preventDefault()
        onUpdate()
      }
    }
    // Remove any existing listener before adding a new one
    document.removeEventListener('keydown', handleKeyDown)
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onUpdate])

  const PreventLeaveDialog = usePreventLeave(!disabled)
  return (
    <div className="flex gap-2">
      <PreventLeaveDialog
        modalOptions={{
          onPrimaryButtonClick: onUpdate,
          onSecondaryButtonClick: onReset,
        }}
      />
      <TooltipWrapper content={tc('reset', { cfl: true })}>
        <Button onClick={onReset} variant="secondary" size="icon" disabled={disabled}>
          <RotateCcwIcon className="size-4" />
        </Button>
      </TooltipWrapper>

      <Button disabled={disabled} onClick={onUpdate}>
        {tc('update', { cfl: true })}{' '}
        <CommandShortcut className="text-primary-400">⌘S</CommandShortcut>
      </Button>
    </div>
  )
}
